// TODO remove them
export const bindEventListeners = (target, events) => {
    for (const [event, listener] of Object.entries(events))
        target.addEventListener(event, listener);
    return {
        cleanup() {
            for (const [event, listener] of Object.entries(events))
                target.removeEventListener(event, listener);
        },
    };
};
const bindKeyboardEvents = (options) => { };
